import cn from 'classnames';
import { Button, CloseButton, Typography } from 'seagull';
import { ExclamationLine24 } from 'seagull/icons';
import styles from "./Banner.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Banner = props => {
  const {
    title,
    actionButtonLabel,
    actionButtonIntent,
    skin = 'warning',
    'data-testid': testId,
    actionButtonOnClick,
    closeButtonOnClick
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": testId,
    className: cn(styles.root, styles["".concat(skin, "Skin")]),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.title,
      children: [/*#__PURE__*/_jsx(ExclamationLine24, {}), /*#__PURE__*/_jsx(Typography, {
        as: "p",
        children: title
      })]
    }), /*#__PURE__*/_jsx(Button, {
      intent: actionButtonIntent,
      "data-testid": "".concat(testId, "-approve-btn"),
      skin: "darkSecondary",
      onClick: actionButtonOnClick,
      children: actionButtonLabel
    }), closeButtonOnClick && /*#__PURE__*/_jsx(CloseButton, {
      onClick: closeButtonOnClick,
      "data-testid": "".concat(testId, "-close-btn")
    })]
  });
};